import React from 'react';
import { Flex, Box, Container, Text } from '@chakra-ui/react';
import SectionTitleCard from './SectionTitleCard';


const AgendaItem = ({ time, description }) => {
  return (
    <Box 
      borderWidth="1px" 
      borderRadius="xl" 
      p={5} 
      mb={4} 
      width={{base: 'full', md: '100%'}} 
      bg="white"
      boxShadow="sm"
      transition="all 0.2s"
      _hover={{
        transform: 'translateX(5px)',
        boxShadow: 'md',
      }}
    >
      <Text 
        fontSize="lg" 
        fontWeight="bold"
        color="blue.600"
      >
        {time}
      </Text>
      <Text 
        mt={2}
        color="gray.600"
      >
        {description}
      </Text>
    </Box>
  );
};

const AgendaSubsectionTitle = ({ children, color }) => (
  <Flex align="center" mb={1}>
    <Box
      px={4}
      py={2}
      borderRadius="xl"
      bgGradient={color || "linear(to-r, blue.100, blue.50)"}
      boxShadow="sm"
      fontWeight="bold"
      fontSize="xl"
      color="blue.700"
      letterSpacing="tight"
      mr={2}
      textAlign="left"
      display="inline-block"
    >
      {children}
    </Box>
  </Flex>
);

const Agenda = () => {
  return (
    <Box id="agenda" p={4}>
    
      {/* <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
        <Heading fontSize={{ base: '2xl', sm: '4xl' }} fontWeight={'bold'}>
          Agenda
        </Heading>
      </Stack> */}

      <Container maxW={'7xl'}>
        <Flex justify="center">
          <SectionTitleCard gradient="linear(to-r, white.100, white.100)">
            Agenda
          </SectionTitleCard>
        </Flex>

        {/* <div style={{ display: 'flex' }}> */}
        {/* <Flex flexWrap="wrap" gridGap={12} justify="center"> */}

      

          <Flex flexWrap="wrap" justify="center">
          {/* Morning */}
          <Box flex="1" width={{ base: '100%', md: '33%' }} margin="10px" padding="10px">
            <AgendaSubsectionTitle color="linear(to-r, blue.100, blue.50)">
              Morning Agenda
            </AgendaSubsectionTitle>
            <Text fontSize="md" color="blue.600" fontWeight="semibold" mb={4} ml={2}>
              Payments & Scaling
            </Text>
            <AgendaItem
                time="09:30 AM - 09:45 AM"
                description="Opening Remarks - Dahlia Malkhi (UCSB Computer Science)"
              />
            <AgendaItem
                time="09:45 AM - 10:05 AM"
                description="Prof. Christian Catalini (Lightspark)"
              />
            <AgendaItem
                time="10:05 AM - 10:25 AM"
                description="Prof. Rod Garratt (UCSB Economics)"
              />
            <AgendaItem
                time="10:30 AM - 11:00 AM"
                description="Coffee Break ☕"
              />
            <AgendaItem
                time="11:00 AM - 11:20 AM"
                description="Prof. Yu Feng (UCSB Computer Science)"
              />
            <AgendaItem
                time="11:20 AM - 11:40 AM"
                description="Mark Logan (Mysten Labs)"
              />
            <AgendaItem
                time="11:40 AM - 12:00 PM"
                description="Brandon Curtis (Eigen Labs)"
              />
          </Box>

          {/* Afternoon */}
          <Box flex="1" width={{ base: '100%', md: '33%' }} margin="10px" padding="10px">
            <AgendaSubsectionTitle color="linear(to-r, blue.100, blue.50)">
              Afternoon Agenda
            </AgendaSubsectionTitle>
            <Text fontSize="md" color="blue.600" fontWeight="semibold" mb={4} ml={2}>
              DeFi & Economics
            </Text>
            <AgendaItem
              time="12:00 PM - 1:30 PM"
              description="Lunch & Poster Session 🍕"
            />
            <AgendaItem
                time="1:30 PM - 1:50 PM"
                description="Prof. Ciamac Moallemi (Columbia Business School)"
              />
            <AgendaItem
                time="1:50 PM - 2:10 PM"
                description="Prof. Mallesh Pai (Consensys, Rice University)"
              />
            <AgendaItem
                time="2:10 PM - 2:30 PM"
                description="Shiv Kapoor (Royco Protocol)"
              />
            <AgendaItem
                time="2:30 PM - 2:50 PM"
                description="Danning Sui (Flashbots)"
              />
          </Box>

          {/* Evening */}
          <Box flex="1" width={{ base: '100%', md: '33%' }} margin="10px" padding="10px">
            <AgendaSubsectionTitle color="linear(to-r, blue.100, blue.50)">
              Evening Agenda
            </AgendaSubsectionTitle>
            <Text fontSize="md" color="blue.600" fontWeight="semibold" mb={4} ml={2}>
              Investments, Regulations, & Community
            </Text>
            <AgendaItem
                time="3:30 PM - 3:50 PM"
                description="Devin Walsh (Uniswap Foundation)"
              />
            <AgendaItem
                time="3:50 PM - 4:10 PM"
                description="Clara Shikhelman (Chaincode)"
              />
            <AgendaItem
                time="4:10 PM - 4:30 PM"
                description="Roman Akhtariev (Osmosis Labs)"
              />
            <AgendaItem
                time="4:30 PM - 4:50 PM"
                description="Jai Massari (Lightspark)"
              />
            <AgendaItem
                time="5:00 PM - 5:15 PM"
                description="Closing Remarks - Bita Abolfathi (Uniswap Foundation)"
              />
          </Box>
          
          </Flex>
          
      {/* </div> */}
       
      </Container>
    </Box>
  );
};

export default Agenda;